

$(document).ready(function(){

    // show/hide mobile search bar when click the search button

   var searchBtn =  $('.compact .fa-search');
   var searchBar = $('.mobile-search-wrapper');
   var searchFirstClick=true;
   
   searchBtn.click(function(){
     if(searchFirstClick){
        searchBar.slideDown();
     } else {
        searchBar.slideUp();
     }
     searchFirstClick= !searchFirstClick;
    });



   // show/hide product full description/truncation

   var readMore = $('.read-more');
   var readLess = $('.read-less');
   var fullDesc = $('.full-desc');
   var truncDesc = $('.truncated-desc');

   readMore.on('click', function(){
      fullDesc.show();
      truncDesc.hide();
   });

   readLess.on('click', function(){
      truncDesc.show();
      fullDesc.hide();
   });


   // remove excess span tags from product description/html editor

  $('.description').find('span').remove();

  // slide down and up the filters on the collection page 
  var toggle = $('#toggle')
  var reveal = $('.filters .body');
  var open=true;
  $('#toggle').click(function(){
   if(open){
      reveal.slideDown(800);
      toggle.addClass('rotate-180');

   } else {
      reveal.slideUp(800);
      toggle.removeClass('rotate-180');
   }
   open= !open;
  });


}); // end doc ready


